// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Box {
  padding: 50px;
  position: absolute;
  top: 175px;
  right: 35%;
  border-radius: 25px;
}

.Box h1 {
  font-size: 33px;
  font-weight: 700;
  line-height: 44px;
  margin: 0;
  padding-bottom: 10px;
  text-align: center;
}

.background-image {
  /* background: url('/src/assets/images/icons.png'); */
  height: 100vh;
  position: relative;
  z-index: 1000;
  background-color: var(--olive3);
}

.slike-logo {
  height: 60px;
  position: relative;
  width: 120px;
  top: 100px;
  left: 600px;
}

.btn-success {
  float: right;
}

/* .input-txt {
  width: 94%;
  input{
  padding: 7px 10px;
  }
} */
.loginWelcome {
  /* background: url('/src/assets/images/icons.png'); */
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: #c7d2f7;
  gap: 20px;
  padding: 30px;
  align-items: center;
  justify-content: center;
}

.loginButton {
  /* padding-right: 25px; */
  padding-bottom: 20px;
}

.left {
  width: 55%;
}

.slikeLogo {
  display: flex;
  justify-content: center;
}

.slikeLogo img {
  height: 70px;
}

.slikeMsg {
  padding: 40px 0 40px;
  border-bottom: 1px solid rgba(121, 121, 121, 0.3);
  text-align: center;
}

.slikeMsg h1 {
  color: #0d47a1;
  padding-bottom: 20px;
  font-size: 24px;
}

.slikeMsg p {
  color: #020b3d;
  font-size: 18px;
}

.selectBox {
  display: flex;
  justify-content: space-between;
  color: #020b3d;
  padding-top: 30px;
  gap: 20px;
}

.selectBox div {
  width: 200px;
  text-align: center;
  padding: 15px 6px 9px;
  background-color: white;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 14px;
}

.selectBox h5 {
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.selectBox p {
  font-size: 14px;
  line-height: 19px;
}

.svgDiv {
  height: 48px;
  padding: 5px 0 0;
}

.svgDiv svg {
  fill: rgba(2, 11, 61, 0.9);
}

.login {
  padding: 45px 30px 50px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}

.login h2 {
  font-size: 30px;
  font-weight: 700;
  line-height: 44px;
  text-align: center;
  color: rgb(2, 11, 61);
  margin: 0;
  padding-bottom: 10px;
  width: 100%;
  display: flex;
}

.errorMsg {
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  color: #f44336;
  margin-bottom: 10px;
}

.formInput {
  position: relative;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;
}

input {
  padding: 18px 0px;
  height: 100%;
  width: 100%;
  border: 0;
  outline: none;
}

.logButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  color: rgb(255, 255, 255);
  border-radius: 4px;
  background-color: rgb(13, 71, 161);
  cursor: pointer;
  border: 0;
  padding: 13px;
}

.formlogin {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.formlogin input {
  padding: 18px 10px;
}

.contactUs {
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 19px;
  padding-bottom: 20px;
}

.contactUs a {
  color: rgb(0, 122, 255);
}

.contactUs span {
  color: rgb(0, 0, 0);
}

.mobileLogin {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid rgba(112, 112, 112, 0.3);
}

.mobileLogin a {
  font-size: 14px;
  line-height: 19px;
  color: rgb(0, 122, 255);
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./components/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;AACF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AAEF;;AACA;EACE,qDAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,+BAAA;AAEF;;AAAA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;;;;;GAAA;AAOA;EACE,qDAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIF;;AAFA;EACE,yBAAA;EACA,oBAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAJA;EACE,aAAA;EACA,uBAAA;AAOF;;AALA;EACE,YAAA;AAQF;;AANA;EACE,oBAAA;EACA,iDAAA;EACA,kBAAA;AASF;;AAPA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;AAUF;;AARA;EACE,cAAA;EACA,eAAA;AAWF;;AARA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;AAWF;;AATA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mDAAA;EACA,mBAAA;AAYF;;AAVA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAaF;;AAXA;EACE,eAAA;EACA,iBAAA;AAcF;;AAXA;EACE,YAAA;EACA,gBAAA;AAcF;;AAZA;EACE,0BAAA;AAeF;;AAbA;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;AAgBF;;AAdA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;AAiBF;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAkBF;;AAhBA;EACE,kBAAA;EACA,oCAAA;EACA,kBAAA;AAmBF;;AAjBA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AAoBF;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AAqBF;;AAnBA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAsBF;;AApBA;EACE,kBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAwBF;;AAtBA;EACE,uBAAA;AAyBF;;AAvBA;EACE,mBAAA;AA0BF;;AAxBA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,8CAAA;AA2BF;;AAzBA;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AA4BF","sourcesContent":[".Box {\n  padding: 50px;\n  position: absolute;\n  top: 175px;\n  right: 35%;\n  border-radius: 25px;\n}\n.Box h1 {\n  font-size: 33px;\n  font-weight: 700;\n  line-height: 44px;\n  margin: 0;\n  padding-bottom: 10px;\n  text-align: center;\n}\n\n.background-image {\n  /* background: url('/src/assets/images/icons.png'); */\n  height: 100vh;\n  position: relative;\n  z-index: 1000;\n  background-color: var(--olive3);\n}\n.slike-logo {\n  height: 60px;\n  position: relative;\n  width: 120px;\n  top: 100px;\n  left: 600px;\n}\n.btn-success {\n  float: right;\n}\n/* .input-txt {\n  width: 94%;\n  input{\n  padding: 7px 10px;\n  }\n} */\n\n.loginWelcome {\n  /* background: url('/src/assets/images/icons.png'); */\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  background-color: #c7d2f7;\n  gap: 20px;\n  padding: 30px;\n  align-items: center;\n  justify-content: center;\n}\n.loginButton {\n  /* padding-right: 25px; */\n  padding-bottom: 20px;\n}\n.left {\n  width: 55%;\n}\n.slikeLogo {\n  display: flex;\n  justify-content: center;\n}\n.slikeLogo img {\n  height: 70px;\n}\n.slikeMsg {\n  padding: 40px 0 40px;\n  border-bottom: 1px solid rgb(121, 121, 121, 0.3);\n  text-align: center;\n}\n.slikeMsg h1 {\n  color: #0d47a1;\n  padding-bottom: 20px;\n  font-size: 24px;\n}\n.slikeMsg p {\n  color: #020b3d;\n  font-size: 18px;\n}\n\n.selectBox {\n  display: flex;\n  justify-content: space-between;\n  color: #020b3d;\n  padding-top: 30px;\n  gap: 20px;\n}\n.selectBox div {\n  width: 200px;\n  text-align: center;\n  padding: 15px 6px 9px;\n  background-color: white;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 14px;\n}\n.selectBox h5 {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n}\n.selectBox p {\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.svgDiv {\n  height: 48px;\n  padding: 5px 0 0;\n}\n.svgDiv svg {\n  fill: rgb(2, 11, 61, 0.9);\n}\n.login {\n  padding: 45px 30px 50px;\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 3px 6px #00000029;\n}\n.login h2 {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 44px;\n  text-align: center;\n  color: rgb(2, 11, 61);\n  margin: 0;\n  padding-bottom: 10px;\n  width: 100%;\n  display: flex;\n}\n.errorMsg {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n  color: #f44336;\n  margin-bottom: 10px;\n}\n.formInput {\n  position: relative;\n  border: 1px solid rgb(221, 221, 221);\n  border-radius: 4px;\n}\ninput {\n  padding: 18px 0px;\n  height: 100%;\n  width: 100%;\n  border: 0;\n  outline: none;\n}\n.logButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n  color: rgb(255, 255, 255);\n  border-radius: 4px;\n  background-color: rgb(13, 71, 161);\n  cursor: pointer;\n  border: 0;\n  padding: 13px;\n}\n.formlogin {\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.formlogin input {\n  padding: 18px 10px;\n}\n.contactUs {\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n  line-height: 19px;\n  padding-bottom: 20px;\n}\n.contactUs a {\n  color: rgb(0, 122, 255);\n}\n.contactUs span {\n  color: rgb(0, 0, 0);\n}\n.mobileLogin {\n  display: flex;\n  justify-content: center;\n  padding-top: 20px;\n  border-top: 1px solid rgb(112, 112, 112, 0.3);\n}\n.mobileLogin a {\n  font-size: 14px;\n  line-height: 19px;\n  color: rgb(0, 122, 255);\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
